import { Link, Text } from '@change/ds-core-ui/next';

export type NameProps = {
	publiclyVisible: boolean;
	slug: string | null;
	id: string;
	displayName: string;
};

export const Name: React.FC<NameProps> = ({ displayName, id, publiclyVisible, slug }) => {
	return (
		<>
			{publiclyVisible ? (
				<Link
					variant="secondary"
					bold
					data-qa="dm-link"
					href={`/decision-makers/${slug || id}?source_location=petition_details_gamma_legislative_bodies`}
					className="mr-2"
				>
					<Text variant="heading" size="x-small">
						{displayName}
					</Text>
				</Link>
			) : (
				<Text variant="heading" size="x-small" className="mr-2">
					{displayName}
				</Text>
			)}
		</>
	);
};
